import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OutcomeModalComponent } from './outcome-modal/outcome-modal.component';
import { environment } from '../../environments/environment';
import { decodeBase64ToText, encodeToBase64, formatDate } from '../utility';
import { HomeService } from './home.service';
import { ApiService } from '../api.service';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { MessageService } from 'primeng/api';
import { HelperService } from '../shared/services/helper.service';
import { PageMetadataService } from '../shared/services/page-metadata.service';
import { HttpService } from '../shared/services/http.service';
import { SidebarService } from '../shared/services/sidebar.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit, OnDestroy {
  env = environment;
  ref: DynamicDialogRef | undefined;
  statusCardCount: any;
  totalCount: number = 0;
  isSidebarOpen: boolean = false;
  isLoading: boolean = true;
  userData: any;
  themes: any[];
  currentQuater: any;
  currentGroup: any;
  currentTheme: any;
  category: string;
  teamMembersLists: any = [];
  selectedQuarter: string = '1'; // Default selected value
  quarter: any[];
  currentYear: any = new Date().getFullYear();
  filterCount: number=0;
  businessThemeLists: any = [];

  statusCard = [
    {
      title: 'Not Started',
      count: '01',
      iconName: 'hugeFolderRemove',
      iconColor: '#544f4f',
      iconBoxColor: '#544f4f1a',
      selected: 'notstarted',
    },
    {
      title: 'Ongoing',
      count: '01',
      iconName: 'hugeClock05',
      iconColor: '#FFAA00',
      iconBoxColor: '#FFAA001a',
      selected: 'ongoing',
    },
    {
      title: 'Completed',
      count: '01',
      iconName: 'hugeFolderCheck',
      iconColor: '#00B458',
      iconBoxColor: '#00B4581a',
      selected: 'completed',
    },
    {
      title: 'Delayed',
      count: '01',
      iconName: 'hugeAlert02',
      iconColor: '#FF1F26',
      iconBoxColor: '#FF1F261a',
      selected: 'delayed',
    },
    {
      title: 'Terminated',
      count: '01',
      iconName: 'hugeCancelCircleHalfDot',
      iconColor: '#8C0000',
      iconBoxColor: '#8C00001a',
      selected: 'terminated',
    },
  ];

  dashboardCard = [
    {
      title: 'Progress',
      iconName: 'hugePieChart',
      iconPath: this.env.assetUrl + '/icon/hugePieChart.svg',
      iconColor: '#FF7D29',
      bgColor: 'linear-gradient(102deg, #FAC150 0.58%, #FA0 100%)',
      vectorPath: this.env.assetUrl + '/progress_db_vector.svg',
    },
    {
      title: 'Kanban',
      iconName: 'hugeChartColumn',
      iconPath: this.env.assetUrl + '/icon/custom.svg',
      iconColor: '#BC36F0',
      bgColor: 'linear-gradient(102deg, #D989F8 0%, #BC36F0 100%)',
      vectorPath: this.env.assetUrl + '/kanban_db_vector.svg',
    },
  ];
  private roleSubscription: Subscription;
  private quaterSubscription: Subscription;
  private groupSubscription: Subscription;
  private themeSubscription: Subscription;
  private homeService = inject(HomeService);
  private apiService = inject(ApiService);
  private messageService = inject(MessageService);
  private readonly auth = inject(AuthService);
  helper = inject(HelperService);
  httpService = inject(HttpService);
  isStatusCountLoad: boolean = true;
  sidebarService=inject(SidebarService)
  constructor(
    private authService: AuthService,
    private router: Router,
    public dialogService: DialogService,
    private pageMetadataService: PageMetadataService
  ) {this.pageMetadataService.setTitle('Home | OBP')}

  ngOnInit(): void {
    this.helper.fetchThemeList();
    //this.fetchCurrentQuater();
    this.sidebarService.cleanHomeSelection();
    this.authService.getLoggedInUser();
    this.userData = JSON.parse(decodeBase64ToText(this.auth.getCookie()));

    this.roleSubscription = this.apiService.role$.subscribe((data) => {
      this.category = data;
      this.fetchCurrentYear(data)
      this.getThemes(data);
    });

    // this.quaterSubscription = this.apiService.quarter$
    //   .pipe(
    //     distinctUntilChanged((prev, curr) => prev === curr) // Only emits when `currentQuater` is different from the previous value
    //   )
    //   .subscribe((data) => {
    //     if (
    //       data !== '' &&
    //       this.currentQuater !== '' &&
    //       this.currentQuater !== data
    //     ) {
    //       this.currentQuater = data;
    //       this.countByStatus(this.category);
    //     }
    //   });

    // this.themeSubscription = this.apiService.theme$
    //   .pipe(
    //     distinctUntilChanged((prev, curr) => prev === curr) // Only emits when `currentQuater` is different from the previous value
    //   )
    //   .subscribe((data) => {
    //     if (data !== '' && this.currentTheme !== data) {
    //       this.currentTheme = data;
    //       this.countByStatus(this.category);
    //     }
    //   });

    this.helper.isOutcomeDataLoad$.subscribe((res: any) => {
      if (res) {
        this.onDropdownSelection({...this.sidebarService?.homeData});
      }
    });
     
  }

  getFilledPropertiesCount(data: any) {
    return Object.keys(data).filter(
      (key) => data[key] !== null && data[key] !== '' && data[key] != undefined && data[key] !== 'quarterly'
    )?.length;
  }

  fetchTeamMembersList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/group/members`, {})
      .subscribe((res: any) => {
        this.teamMembersLists = res?.data;
      });
  }

  fetchCurrentYear(cat:any) {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/year`, {})
      .subscribe((res: any) => {
        this.currentYear = res?.data;
        this.quarterList(cat);
        this.fetchCurrentQuater();
      });
  }

  fetchCurrentQuater() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/current/quarter`, {})
      .subscribe((res: any) => {
        this.currentQuater = res?.data?.quarter;
        this.sidebarService.homeData.outcome_quarters=this.currentQuater
        this.sidebarService.homeData.outcome_quarters=this.currentQuater
        this.sidebarService.homeData.outcome_year=new Date().getFullYear()
        this.onDropdownSelection({...this.sidebarService.homeData});
      });
  }

  quarterList(cat: string) {
    const data = {
      year: this.currentYear,
    };
    this.homeService.getQuarterList(data, cat).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          this.quarter = parsedData.data || [];
          this.quarterFields(this.quarter);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  loadCountByStatus(cat: string,data:any) {
    this.isStatusCountLoad = true;
    this.homeService.getCountByStatus(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.statusCardCount = parsedData.data || [];
          this.totalCount = this.statusCardCount.total;
          this.isStatusCountLoad = false;
        } catch (error) {
          this.isStatusCountLoad = false;
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  countByStatus(cat: string) {
    const data: { [key: string]: string } = {
      outcome_type: 'quarterly',
    };

    if (this.currentQuater != null) {
      data['outcome_quarters'] = this.currentQuater;
    }

    if (this.currentGroup != null) {
      //data['outcome_groups'] = this.currentGroup;
    }

    if (this.currentTheme != null && this.currentTheme != '') {
      data['outcome_themes'] = this.currentTheme;
    }
    this.isStatusCountLoad = true;
    this.homeService.getCountByStatus(data, cat).subscribe(
      (data: any) => {
        try {
          const parsedData = data;
          this.statusCardCount = parsedData.data || [];
          this.totalCount = this.statusCardCount.total;
          // this.statusCard[0].count = this.statusCardCount?.notstarted;
          // this.statusCard[1].count = this.statusCardCount?.ongoing;
          // this.statusCard[2].count = this.statusCardCount?.completed;
          // this.statusCard[3].count = this.statusCardCount?.delayed;
          // this.statusCard[4].count = this.statusCardCount?.terminated;
          this.isStatusCountLoad = false;
        } catch (error) {
          this.isStatusCountLoad = false;
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  fetchThemeList() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/themes`, {})
      .subscribe((res: any) => {
        this.businessThemeLists = res?.data;
      });
  }

  getThemes(cat: string) {
    const data = {};
    this.homeService.getthemeList(data, cat).subscribe(
      (data: any) => {

        try {
          const parsedData = data;
          const themeList = parsedData.data || [];
          this.themes = themeList.map((item: any) => ({
            key: item.theme_id,
            value: item.value,
          }));

          //let newItem: any = { "key": "All Theme", "value": -1 };

          // Use unshift() to aDd it at the beginning of the array
          //this.themes.unshift(newItem);
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );
  }

  onDropdownSelection(filterData: any) {
    this.filterCount = this.getFilledPropertiesCount(filterData);
    this.loadCountByStatus(this.category,filterData)
  }

  loadDashboard(dashboardType: string) {
    if (dashboardType == 'Kanban') {
      this.router.navigate(['kanban-view']);
    } else {
      this.router.navigate(['progress-view']);
    }
  }

  showOutcomes(modalHeader: string, title: any) {
    this.ref = this.dialogService.open(OutcomeModalComponent, {
      // header: modalHeader,
      width: '85%',
      contentStyle: { 'max-height': '500px', overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        // Pass the custom data here
        title: title,
        businessThemeLists: this.themes,
        quarter: this.quarter,
        currentYear:this.currentYear,
        currentTheme: this.currentTheme,
      },
    });
  }

  quarterFields(timelines: any[]) {
    timelines.forEach((timeline) => {
      timeline.quarterVal = `Cycle ${timeline.quarter}`;
    });
  }

  showAlert() {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: '0 Outcomes',
    });
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
    if (this.roleSubscription) {
      this.roleSubscription.unsubscribe(); // Clean up subscription when component is destroyed
    }

    if (this.quaterSubscription) {
      this.quaterSubscription.unsubscribe();
    }

    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    this.sidebarService.cleanHomeSelection();
  }
}
